import React, {memo} from 'react'

import PropTypes from 'prop-types'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import MoleculeModal from '@s-ui/react-molecule-modal'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

const SearchSortModal = ({isOpen = false, onClose, title, children}) => (
  <MoleculeModal
    isOpen={isOpen}
    closeOnOutsideClick
    closeOnEscKeyDown
    fitWindow
    iconClose={<IconClose aria-hidden role="presentation" size={ATOM_ICON_SIZES.medium} />}
    onClose={onClose}
  >
    <TitleBasic as={titleBasicTags.h2} title={title} size={titleBasicSizes.s} />
    {children}
  </MoleculeModal>
)

SearchSortModal.displayName = 'SearchSortModal'
SearchSortModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}

const MemoSearchSortModal = memo(SearchSortModal)

MemoSearchSortModal.displayName = 'MemoSearchSortModal'

export default MemoSearchSortModal
